import React from 'react';
// Data
import { babyGalleryItemsArray } from '../../utils/data/GalleryData';

function BabyGalleryMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12'>
      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto gap-8 py-12 md:grid-cols-2 lg:grid-cols-3'>
          {babyGalleryItemsArray.map((item, index) => (
            <figure key={index} className='w-full group overflow-hidden h-full max-h-[70vh]'>
              <img
                src={item.url}
                alt={item.alt}
                aria-label={item.ariaLabel}
                className='w-full h-full object-cover shadow-md transition-transform duration-500 ease-in-out group-hover:scale-105 max-h-[70vh]'
              />
              <figcaption className='mt-2 text-sm text-center text-colour2 dark:text-colour1 italic'>
                {item.title}
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </main>
  );
}

export default BabyGalleryMainContainer;
